import { render, staticRenderFns } from "./MetricsChart.vue?vue&type=template&id=1bfb7b08"
import script from "./MetricsChart.vue?vue&type=script&lang=js"
export * from "./MetricsChart.vue?vue&type=script&lang=js"
import style0 from "./MetricsChart.vue?vue&type=style&index=0&id=1bfb7b08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports